import React from "react";
import hero from '../assets/img/Industries/academy_hero.jpg';
import academia_sub_1 from '../assets/img/Industries/academia_sub_1.png';
import academia_sub_2 from '../assets/img/Industries/academia_sub_2.png';
import academia_sub_3 from '../assets/img/Industries/academia_sub_3.png';
import academia_sub_4 from '../assets/img/Industries/academia_sub_4.png';
import { Link as RouterLink } from 'react-router-dom';

const Academia = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="pharma" className="about text-start" style={{paddingTop:'40px'}}>
                    <div className="ph-hero academy-hero" style={{position:'relative'}}>
                        <div className="ph-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <div className="ph-title-content" style={{color:'#fff'}}>
                                <h1>Revolutionize Research with the Ultimate LIMS- ELN for Academic Labs</h1>
                                <p>Take your research to the next level with Lab Iconics—an all-in-one platform designed for academic laboratories. From data management to experiment tracking, Lab Iconics simplifies lab operations, so your team can focus on making scientific breakthroughs.</p>
                            </div>
                            <div className="book_a_demo">
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        <div>
                            <img src="" alt="" />
                        </div>

                    </div>
                    {/* <div>
                        <img src={hero} alt="" style={{height:'60vh', width:'100%'}}/>
                    </div> */}

                    <div className="section-container" style={{marginTop:'0'}}>
                        <div className="row">
                            {/* <div><h1 style={{textAlign:'center', fontSize:'40px'}}>Key Benifits</h1></div> */}
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-img academia-imgs" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={academia_sub_1} alt="acd-imgs"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Centralized Data Management</h1></div>
                                        {/* <span>Securely store, organize, and retrieve research data to prevent loss and ensure compliance. </span> */}
                                        <ul>
                                            <li><b>Secure Storage – </b> Store all research data in one centralized, cloud-based system with automatic backups.</li>
                                            <li><b>Quick Access – </b>Retrieve past experiments, protocols, and results instantly with an intuitive search. </li>
                                            <li><b>Version Control – </b> Track data modifications and maintain multiple versions for transparency.</li>
                                            <li><b>Regulatory Compliance – </b> Ensure adherence to institutional and funding agency guidelines.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sec-out" style={{paddingTop:'2rem'}}>
                                    <div className="sec-pro-img academia-imgs" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={academia_sub_2} alt="acd-imgs"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Streamlined Collaboration</h1></div>
                                        <ul>
                                            <li><b>Real-time Data Sharing – </b> Enable seamless collaboration with secure, cloud-based access.</li>
                                            <li><b>Cross-team Integration – </b> Connect researchers across departments and institutions.</li>
                                            <li><b>Role-based Access – </b> Control permissions to safeguard sensitive research while fostering teamwork.</li>
                                            <li><b>Remote Access – </b> Work from anywhere with secure login to lab resources.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title-2"><h1> Enhanced Experiment Reproducibility</h1></div>
                                        <ul className='sec-ul'>
                                            <li style={{hyphens:'auto'}}><b>Standardized Protocols –</b> Document and store experiment protocols for consistency. </li>
                                            <li style={{hyphens:'auto'}}><b>Automated Tracking –  </b>Log every step of an experiment to improve repeatability and accuracy. </li>
                                            <li style={{hyphens:'auto'}}><b>Data Integrity – </b> Ensure unaltered, audit-ready data for publications and funding reports.</li>
                                            <li style={{hyphens:'auto'}}><b>Publication-ready Reports  – </b> Generate structured reports effortlessly for research papers.</li>
                                        </ul>
                                    </div>
                                    <div className="sec-pro-img academia-imgs" data-aos="fade-up" data-aos-delay="100">
                                        <img src={academia_sub_3} alt="acd-imgs" />
                                    </div>  
                                </div>
                            </div>
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title-2"><h1> Efficient Lab Resource Management</h1></div>
                                        <ul className='sec-ul'>
                                            <li style={{hyphens:'auto'}}><b>Smart Inventory Tracking –</b> Monitor reagent usage, automate reorders, and prevent shortages.  </li>
                                            <li style={{hyphens:'auto'}}><b>Equipment Scheduling –  </b>Optimize instrument usage and minimize downtime.  </li>
                                            <li style={{hyphens:'auto'}}><b>Cost Optimization – </b>Reduce waste by tracking expiration dates and avoiding duplicate purchases.</li>
                                            <li style={{hyphens:'auto'}}><b>Usage Analytics – </b> Gain insights into resource consumption for better budgeting and planning.</li>
                                        </ul>
                                    </div>
                                    <div className="sec-pro-img academia-imgs" data-aos="fade-up" data-aos-delay="100">
                                        <img src={academia_sub_4} alt="acd-imgs" />
                                    </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default Academia;